import { render } from "./GoogleIcon.vue?vue&type=template&id=11ad0d8d"
const script = {}
script.render = render

export default script